export const activitySectorIdsQuestion = [
    1159,
    1164,
    1169,
    1174,
    1179,
    1184,
    1189,
    1194,
    1199,
    1204,
    1209,
    1214,
    1219,
    1224,
    1232,
    1237,
    1242,
    1247,
    1252,
    1258,
    1263,
    1268,
    1275,
    1280,
    1286,
    1291,
    1296,
    1301,
    1306,
    1311,
    1316,
    1321,
    1326,
    1331,
    1336,
    1342,
    1347,
    1352,
    1357,
    1362,
    1367,
    1372,
    1377,
    1382,
    1387,
    1392,
    1398,
    1403,
    1408,
    1413,
    1423,
    1467,
    1478,
    1488,
    1493,
    1498,
    1503,
    1509,
    1515,
    1520,
    1525,
    1530,
    1535,
    1540,
    1545,
    1550,
    1555,
    1562,
    1572,
    1579,
    1589,
    1594,
    1599,
    1604,
    1611,
    1616,
    1621,
    1626,
    1631,
    1636,
    1641,
    1646,
    1669,
    1674,
    1685,
    1690,
    1695,
    1700,
    1705,
    1710,
    1715,
    1720,
    1725,
    1730,
    1736,
    1745,
    1750,
    1771,
    1776,
    1783,
    1792,
    1797,
]

export const activosFijosIdsQuestion = [
    1162,
    1167,
    1172,
    1177,
    1182,
    1187,
    1192,
    1197,
    1202,
    1207,
    1212,
    1217,
    1222,
    1227,
    1235,
    1240,
    1245,
    1250,
    1255,
    1261,
    1266,
    1271,
    1278,
    1283,
    1289,
    1294,
    1299,
    1304,
    1309,
    1314,
    1319,
    1324,
    1329,
    1334,
    1339,
    1345,
    1350,
    1355,
    1360,
    1365,
    1370,
    1375,
    1380,
    1385,
    1390,
    1395,
    1401,
    1406,
    1411,
    1416,
    1426,
    1470,
    1481,
    1491,
    1496,
    1501,
    1506,
    1512,
    1518,
    1523,
    1528,
    1533,
    1538,
    1543,
    1548,
    1553,
    1558,
    1565,
    1575,
    1582,
    1592,
    1597,
    1602,
    1607,
    1614,
    1619,
    1624,
    1629,
    1634,
    1639,
    1644,
    1649,
    1672,
    1677,
    1688,
    1693,
    1698,
    1703,
    1708,
    1713,
    1718,
    1723,
    1728,
    1733,
    1739,
    1748,
    1753,
    1774,
    1779,
    1786,
    1795,
    1800,
]

export const activosTotalesIdsQuestion = [
    1163,
    1168,
    1173,
    1178,
    1183,
    1188,
    1193,
    1198,
    1203,
    1208,
    1213,
    1218,
    1223,
    1228,
    1236,
    1241,
    1246,
    1251,
    1256,
    1262,
    1267,
    1272,
    1279,
    1284,
    1290,
    1295,
    1300,
    1305,
    1310,
    1315,
    1320,
    1325,
    1330,
    1335,
    1340,
    1346,
    1351,
    1356,
    1361,
    1366,
    1371,
    1376,
    1381,
    1386,
    1391,
    1396,
    1402,
    1407,
    1412,
    1417,
    1427,
    1471,
    1482,
    1492,
    1497,
    1502,
    1507,
    1513,
    1519,
    1524,
    1529,
    1534,
    1539,
    1544,
    1549,
    1554,
    1559,
    1566,
    1576,
    1583,
    1593,
    1598,
    1603,
    1608,
    1615,
    1620,
    1625,
    1630,
    1635,
    1640,
    1645,
    1650,
    1673,
    1678,
    1689,
    1694,
    1699,
    1704,
    1709,
    1714,
    1719,
    1724,
    1729,
    1734,
    1740,
    1749,
    1754,
    1775,
    1780,
    1787,
    1796,
    1801,
]

